var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 12L17.7 7.7C18.1 7.3 18.1 6.7 17.7 6.3C17.3 5.9 16.7 5.9 16.3 6.3L12 10.6L7.7 6.3C7.3 5.9 6.7 5.9 6.3 6.3C5.9 6.7 5.9 7.3 6.3 7.7L10.6 12L6.3 16.3C6.1 16.5 6 16.7 6 17C6 17.6 6.4 18 7 18C7.3 18 7.5 17.9 7.7 17.7L12 13.4L16.3 17.7C16.5 17.9 16.7 18 17 18C17.3 18 17.5 17.9 17.7 17.7C18.1 17.3 18.1 16.7 17.7 16.3L13.4 12Z",
    fill: "#38369C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.4210a30827a448ddb304064d5c312443.svg";
export { ForwardRef as ReactComponent };